import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import cls from "./ClubShop.module.scss";

const ClubShop = () => {
  const { clubId } = useParams();
  const location = useLocation();

  const clubBase = `/lounge/clubs/single/${clubId}`;
  const tabs = [
    { key: "feed", label: "Feed", to: `${clubBase}/home` },
    { key: "members", label: "Members", to: `${clubBase}/members` },
    { key: "events", label: "Events", to: `${clubBase}/events` },
    { key: "shop", label: "Shop", to: `${clubBase}/shop` },
  ];

  const isActiveTab = (to) => location.pathname.startsWith(to);

  return (
    <section className={cls.page}>
      <div className={cls.pageInner}>
        <nav className={cls.tabs} aria-label="Club tabs">
          {tabs.map((tab) => (
            <Link
              key={tab.key}
              to={tab.to}
              className={`${cls.tab} ${isActiveTab(tab.to) ? cls.activeTab : ""}`}
            >
              {tab.label}
            </Link>
          ))}
        </nav>

        <article className={cls.card}>
          <h1 className={cls.title}>🛍 Club Marketplace – Coming Soon</h1>
          <p className={cls.lead}>
            A new space for members to buy, sell, and offer services inside the
            Noty Universe community.
          </p>

          <p>
            The Club Marketplace is being built as a trusted marketplace where
            verified members can exchange products, services, and digital
            experiences within the community.
          </p>
          <p>
            Everything inside the marketplace will run using{" "}
            <strong>Noty Coin</strong>, the platform’s internal currency.
          </p>

          <h2>🛒 Buy Products &amp; Services</h2>
          <p>
            Members will be able to explore and purchase a wide range of items
            from other members, including:
          </p>
          <ul>
            <li>Physical products</li>
            <li>Digital products</li>
            <li>Personal services</li>
            <li>Creative content and experiences</li>
          </ul>
          <p>
            All payments inside the marketplace will be made using Noty Coin,
            making transactions simple and secure within the platform.
          </p>

          <h2>💼 Sell Your Products or Services</h2>
          <p>
            Members will also have the opportunity to sell their own physical or
            digital products and services to the community.
          </p>
          <p>
            Whether it is a product you created, a digital resource, or a
            service you provide, the Club Marketplace will give you a place to
            offer it to other verified members.
          </p>

          <h2>💰 Earn with Noty Coin</h2>
          <p>
            When you sell a product or service, you will receive Noty Coin in
            your wallet.
          </p>
          <p>
            Members will have the option to convert their Noty Coin into their
            preferred currency whenever they choose.
          </p>
          <p>
            To process the conversion, banking charges and platform service fees
            will apply.
          </p>

          <h2>🔒 Safe Community Marketplace</h2>
          <p>
            Because the marketplace is part of the Noty Universe ecosystem, it
            is designed to operate within a verified member community, helping
            create a more trusted and reliable environment for transactions.
          </p>

          <p className={cls.footerNote}>
            ✨ The Club Marketplace will be available soon. Stay tuned.
          </p>
        </article>
      </div>
    </section>
  );
};

export default ClubShop;
